module.exports = __webpack_public_path__ + "static/media/antigua-historic-3.c23ee134.jpg";